import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { AppConfigLoader } from '../../config/app-config.loader';
import { ToastService } from '../services/toast.service';

export const apiErrorToastInterceptor: HttpInterceptorFn = (request, next) => {
  const toast = inject(ToastService);
  const appConfigLoader = inject(AppConfigLoader);

  return next(request).pipe(
    catchError((error: unknown) => {
      const error_ = error as any;
      const authOrigin = new URL(appConfigLoader.activeConfig().auth.issuer).origin;
      const isAuthEndpoint = request.url.startsWith(authOrigin);
      const isAlbumCreateEndpoint = request.url.includes('/albums');

      if (error_.status === 400 && !isAuthEndpoint && !isAlbumCreateEndpoint) {
        const description = error_.error.error_description ?? error_.error.message ?? error_.error.error;
        toast.showBadRequestToast(description as string);
      }
      return throwError(() => error_);
    })
  );
};
